import React, { Component } from 'react';

export default class ApplyForMembership extends Component {
  render() {
    return (
      <div>
        <h1>Ansökan</h1>
        <p>Ansök om medlemskap genom att...</p>
      </div>
    );
  }
}
